import React, { useEffect, useState } from "react";

import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useCookies, withCookies } from "react-cookie";

import {
  Container,
  Row,
  Col,
  Modal,
  Spinner,
  Image,
  Form,
} from "react-bootstrap";
import Footer from "../../../../components/Footer/footer.component";
import HeaderOwner from "../../../../components/HeaderOwner/header-owner.component";
import Button from "../../../../components/Button/button.component";
import TextInput from "../../../../components/TextInput/text-input.component";

import {
  addTeacher,
  updateTeacher,
  getTeacherDetail,
  setStatusDefault,
  getTeacher,
  clearAddTeacherRes,
} from "../../../../redux/owner/owner.action";
import AtomLoading from "../../../../components/loding-indicator";
import OnboardingStatus from "../../../../components/onboarding-status";
import { ModalLogin } from "../../../StudioLogin/modal";
import { activateAccountUser } from "../../../../redux/user/user.action";
import OrganismLayout from "../../../../components/Layout/organism-layout";

const AddTeachers = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [cookies] = useCookies(["user"]);
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [sendEmail, setSendEmail] = useState(false);
  const [showModalReactivateTeacher, setShowModalReactivateTeacher] =
    useState(false);

  const {
    teacher,
    teacher_detail,
    addTeacherStatus,
    updateTeacherStatus,
    isLoadingTeacher,
    onboarding_status,
    add_teacher_res,
  } = useSelector((state) => state.owner);
  const { isRegisterStudent } = useSelector((state) => state.studio);
  const { user, loginFromStudio } = useSelector((state) => state.user);

  const id = props.location.state?.id;
  const isOnboarding = props.location.state?.isOnboarding;
  const isCreating = window.location.pathname.includes("add") ? true : false;
  const user_token =
    loginFromStudio || isRegisterStudent ? user?.token : cookies.user?.token;
  const studio_id =
    loginFromStudio || isRegisterStudent
      ? user?.studio_id
      : cookies.user?.studio_id;

  const handleActivateAccount = async () => {
    try {
      await dispatch(
        activateAccountUser(user_token, studio_id, {
          email: email,
          role: "teacher",
        })
      );
      history.goBack();
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let params = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone_number: phoneNumber,
      send_welcome_email: sendEmail ? 1 : 0,
    };
    isCreating
      ? dispatch(addTeacher(params, user_token, studio_id))
      : dispatch(
          updateTeacher(
            {
              first_name: firstName,
              last_name: lastName,
              email: email,
              phone_number: phoneNumber,
            },
            user_token,
            studio_id,
            id
          )
        );
  };

  useEffect(() => {
    if (id) dispatch(getTeacherDetail(user_token, studio_id, id));
  }, [id]);

  useEffect(() => {
    if (id) {
      setFirstName(teacher_detail?.first_name);
      setLastName(teacher_detail?.last_name);
      setEmail(teacher_detail?.email);
      setPhoneNumber(teacher_detail?.phone_number);
    }
  }, [teacher_detail]);

  useEffect(() => {
    if (add_teacher_res?.is_account_active === 0) {
      setShowModalReactivateTeacher(true);
      return;
    }
    if (addTeacherStatus === "success" || updateTeacherStatus === "success") {
      history.push("/teachers");
      dispatch(clearAddTeacherRes());
    } else if (addTeacherStatus === "success" && isOnboarding) {
      onboarding_status?.schedule_class === false
        ? history.push({
            pathname: "/add-class",
            state: { isOnboarding: true },
          })
        : onboarding_status?.plan === false
        ? history.push({
            pathname: "/add-plan",
            state: { isOnboarding: true },
          })
        : onboarding_status?.term_and_condition === false
        ? history.push({
            pathname: "/setting-terms-and-conditions",
            state: { isOnboarding: true, step: 2 },
          })
        : onboarding_status?.cancellation_setting === false
        ? history.push({
            pathname: "/setting-cancellation",
            state: { isOnboarding: true, step: 2 },
          })
        : onboarding_status?.payment_information === false
        ? history.push({
            pathname: "/setting-payment",
            state: { isOnboarding: true, step: 2 },
          })
        : history.goBack();
    }
    // dispatch(getTeacher(user_token, studio_id, 1));
    dispatch(setStatusDefault());
  }, [addTeacherStatus, updateTeacherStatus, isOnboarding]);

  return (
    <>
      <OrganismLayout
        maxWidth="32rem"
        title={isCreating ? "Add Teacher" : "Edit Teacher"}
        onBoardingStatus={
          isOnboarding && <OnboardingStatus selectedStep={1} activeStep={2} />
        }
      >
        {isLoadingTeacher ? (
          <AtomLoading />
        ) : (
          <Col>
            <Form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <Form.Group style={{ marginBottom: 10 }}>
                <TextInput
                  required
                  label="First Name"
                  placeholder="John"
                  value={firstName}
                  onChange={(event) => {
                    setFirstName(event.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group style={{ marginBottom: 10 }}>
                <TextInput
                  label="Last Name"
                  placeholder="Chena"
                  value={lastName}
                  onChange={(event) => {
                    setLastName(event.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group style={{ marginBottom: 10 }}>
                <TextInput
                  inputClassName={`${!isCreating && "border-0"}`}
                  required={isCreating}
                  readOnly={!isCreating}
                  label="Email Address"
                  placeholder="John@gmail.com"
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                />
              </Form.Group>
              <Form.Group style={{ marginBottom: 10 }}>
                <TextInput
                  type="number"
                  label="Phone Number"
                  placeholder="087878****"
                  value={phoneNumber}
                  onChange={(event) => {
                    setPhoneNumber(event.target.value);
                  }}
                />
              </Form.Group>
              {isCreating && (
                <Form.Group>
                  <Form.Check
                    id="sent"
                    type="checkbox"
                    label="Send welcome email"
                    style={{
                      fontFamily: "Roboto",
                      fontSize: 14,
                      color: "#000",
                    }}
                    onChange={(event) => {
                      setSendEmail(event.target.checked);
                    }}
                  />
                </Form.Group>
              )}
              <div className="mt-3 mb-2 d-flex justify-content-center gap-3">
                <Button
                  type={"outline-secondary"}
                  title={isOnboarding ? "Skip for Now" : "Cancel"}
                  onClick={() => {
                    if (isOnboarding) {
                      if (teacher?.length === 0) {
                        toast.error(
                          "Please add your teacher first before adding your class."
                        );
                        return;
                      }
                      onboarding_status?.schedule_class === false
                        ? history.push({
                            pathname: "/add-class",
                            state: { isOnboarding: true },
                          })
                        : onboarding_status?.plan === false
                        ? history.push({
                            pathname: "/add-plan",
                            state: { isOnboarding: true },
                          })
                        : onboarding_status?.term_and_condition === false
                        ? history.push({
                            pathname: "/setting-terms-and-conditions",
                            state: { isOnboarding: true, step: 2 },
                          })
                        : onboarding_status?.cancellation_setting === false
                        ? history.push({
                            pathname: "/setting-cancellation",
                            state: { isOnboarding: true, step: 2 },
                          })
                        : onboarding_status?.payment_information === false
                        ? history.push({
                            pathname: "/setting-payment",
                            state: { isOnboarding: true, step: 2 },
                          })
                        : history.goBack();
                    } else {
                      history.goBack();
                    }
                  }}
                />
                <Button
                  isLoading={isLoadingTeacher}
                  type="primary"
                  title="CONTINUE"
                  buttonType="submit"
                />
              </div>
            </Form>
          </Col>
        )}
      </OrganismLayout>

      <ModalLogin
        show={showModalReactivateTeacher}
        title="The Account Is Currently Being Deactivated"
        label="Continue to reactivate the teacher account"
        email={email}
        titleButton1={"Cancel"}
        titleButton2={"REACTIVATE"}
        handleClose={() => setShowModalReactivateTeacher(false)}
        handleSubmit={handleActivateAccount}
      />
    </>
  );
};

export default AddTeachers;
